import { queryFirst } from '../domUtil';
const { ensureFreshCsrfToken } = require('../utils/csrfRefresh');
const SELECTOR_DATA_ELEMENT = '.js-ajax-data';

import cache from './cache';

const { get: getCustomerCache, set: setCustomerCache } = cache({
    keyPrefix: 'customer-',
    ttl: 30
});

const { get: getProductInventoryCache, set: setProductInventoryCache } = cache({
    keyPrefix: 'product-inventory-',
    ttl: 180
});

/**
 * Get account data element
 *
 * @returns {null|HTMLElement} account data el
 */
function getDataElement() {
    return queryFirst(SELECTOR_DATA_ELEMENT);
}

/**
 * Get Customer Data by URL
 * @async
 * @private
 * @param {string} customerDataUrl data base url
 * @returns {Promise<Object>} Customer data object
 */
async function getCustomerDataAjaxResult(customerDataUrl) {
    const result = {
        isAuthenticated: false
    };

    const response = await fetch(customerDataUrl);

    if (!response.ok) {
        return result;
    }
    const { isAuthenticated, isLoyaltyMember } = await response.json();

    result.isAuthenticated = isAuthenticated;
    result.isLoyaltyMember = isLoyaltyMember;

    return result;
}

/**
 * Get Customer Data
 * @async
 * @returns {Promise<Object>} Customer data object
 */
export async function getCustomerData() {
    const dataEl = getDataElement();
    // Warms the DOM token holders for the state-changing POSTs later in the page lifecycle.
    await ensureFreshCsrfToken();
    const cacheKey = 'data';
    const { customerDataUrl } = dataEl.dataset;

    const cachedResult = getCustomerCache(cacheKey);
    if (cachedResult) {
        return cachedResult;
    }

    const result = await getCustomerDataAjaxResult(customerDataUrl);
    setCustomerCache(cacheKey, result);
    return result;
}

/**
 * Get Product inventory
 *
 * @param {string} masterPid master product ID
 * @returns {null|Object} product info
 */
export async function getProductInventoryData(masterPid) {
    let inventory = getProductInventoryCache(masterPid);

    if (inventory) {
        return inventory;
    }

    const dataEl = getDataElement();
    if (!dataEl) {
        return null;
    }
    const { productInventoryUrl } = dataEl.dataset;

    const targetUrl = `${productInventoryUrl}?pid=${masterPid}`;
    const result = {};
    try {
        const response = await fetch(targetUrl);
        const resData = await response.json();
        if (!response.ok) {
            throw new Error('Response was not OK');
        }

        result.variants = resData.variants;
        setProductInventoryCache(masterPid, result);
        return result;
    } catch (e) {
        result.error = true;
        console.error('getProductInventoryData error:', e.message);
        return result;
    }
}
